import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/sysCustomerSecondlevelPerson'


export function getPersonalListById(id) {
  return request({
    url:`${BASE_REQUEST}/getPersonalListById`,
    data:{
      id:id
    }
  })
}

export function savePersonalAccount(obj) {
  return request({
    url:`${BASE_REQUEST}/savePersonalAccount`,
    data:obj
  })
}

export function updatePersonalAccount(obj) {
  return request({
    url:`${BASE_REQUEST}/updatePersonalAccount`,
    data:obj
  })
}

export function delPersonalAccount(id) {
  return request({
    url:`${BASE_REQUEST}/delPersonalAccount`,
    data:{
      id:id
    }
  })
}
